import { NotificationStore } from './types';

export const actionsSelector = (store: NotificationStore) => store.actions;

export const isDisabledSelector = (store: NotificationStore) =>
  store.isDisabled;
